export { default as getGeolocation } from './getGeolocation'
export type { default as Location } from './location'
export { default as useGeolocation } from './useGeolocation'

export const GEOLOCATION_SESSION_KEY = 'geolocation'
